import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PlatformUserCreateComponent } from './components/platform-user-create/platform-user-create.component';
import { PlatformUserUpdateComponent } from './components/platform-user-update/platform-user-update.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PlatfromUserAccssManagementService } from './services/platform-user-access-management.service';
import { FormsModule } from '@angular/forms';
import { AppPlatformTeamManagementContainerComponent } from './components/platform-user-access-management-container/platform-user-access-management-container.component';
import { AppPlatformUserAccessManagementComponent } from './components/platform-user-access-management/platform-user-access-management.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AppPlatformTeamManagementHeaderComponent } from './components/platform-user-access-management-header/platform-user-access-management-header.component';
import { UAMProfileImageUploadService } from './services/platform-profile-image-upload.service';
import { AppProfileImageDialogComponent } from './dialogs/app-profile-image-dialog/app-profile-image-dialog.component';
import { PlatformSharedModule } from '../app-shared-module';
import { InternationalPhoneNumberModule } from '../ngx-international-phone-number';
import { FuseDirectivesModule } from '../template-atlas';
import { PlatformDataTableModule } from '../app-platform-datatable';
import { PlatformImageCropperModule } from '../app-platform-image-cropper';
@NgModule({
    imports: [
        MatSlideToggleModule,
        MatCardModule,
        PlatformDataTableModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatIconModule,
        FuseDirectivesModule,
        FlexLayoutModule.withConfig({
            useColumnBasisZero: false,
            printWithBreakpoints: [
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                'lt-sm',
                'lt-md',
                'lt-lg',
                'lt-xl',
                'gt-xs',
                'gt-sm',
                'gt- md',
                'gt-lg'
            ]
        }),
        RouterModule,
        MatButtonModule,
        CommonModule,
        TranslateModule.forChild(),
        MatMenuModule,
        MatInputModule,
        MatAutocompleteModule,
        FormsModule,
        MatSnackBarModule,
        MatSelectModule,
        InternationalPhoneNumberModule,
        PlatformSharedModule,
        PlatformImageCropperModule,
        MatProgressBarModule
    ],
    exports: [
        AppPlatformUserAccessManagementComponent,
        AppPlatformTeamManagementContainerComponent,
        AppPlatformTeamManagementHeaderComponent,
        PlatformUserCreateComponent,
        PlatformUserUpdateComponent
    ],
    declarations: [
        AppPlatformUserAccessManagementComponent,
        AppPlatformTeamManagementContainerComponent,
        AppPlatformTeamManagementHeaderComponent,
        PlatformUserCreateComponent,
        PlatformUserUpdateComponent,
        AppProfileImageDialogComponent
    ],
    providers: [PlatfromUserAccssManagementService, UAMProfileImageUploadService]
})
export class PlatformUserAccessManagementModule {}
